import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

/**
 * <OutcomeDialog
 *  item
 * 	onOutcome = {amount}
 * 	onCancel = {}
 * />
 */

class OutcomeDialog extends Component {

	state = {
		amount: "",
    comment: "",
	}

	/**
	 * Проверяет, евляется ли значение безннаковым положительным числом.
	 * @param value - значение.
	 * @return true или false.
	 */

	isUnsignedNumber(value) {
    if (!value) {
      return false
    }
		let s = value.toString()
		for (let i = 0; i < s.length; i++) {
			if ((s[i] < '0') || (s[i] > '9')) {
				return false
			}
		}
		return true
	}

	/**
	 * Проверка на корректность ввода.
	 * @return boolean.
	 */

	isReadyToCreate() {
		return this.state.amount !== "" && this.isUnsignedNumber(this.state.amount)
	}

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
  			{`Выдача предмета "${this.props.item.name}"`}
			</DialogTitle>

			<DialogContent style = {{display: "flex", flexDirection: "column"}}>

				<TextField
					value = {this.state.amount}
					label = "Количество предметов"
					margin = "normal"
					onChange = {e => {
						this.setState({
							amount: e.target.value
						})
					}}
				/>

        <TextField
          label = "Комментарий"
          multiline
          rowsMax = "8"
          value = {this.state.comment}
          onChange = {e => {
            this.setState({
              comment: e.target.value
            })
          }}
          margin = "normal"
          variant = "outlined"
        />

			</DialogContent>

			<DialogActions>

				<Button
					disabled = {!this.isReadyToCreate()}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onOutcome === "function") {
							this.props.onOutcome(parseInt(this.state.amount), this.state.comment)
						}
					}}
				>Ок</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default OutcomeDialog
